import { Box } from "@material-ui/core";

import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { DataAftercare } from "../../quoteDetail.constants";
import { TopBox } from "../../../../components/TopBox";
import { BotBox } from "../../../../components/BotBox";
import { useAftercareStyles } from "./afterCare.styles";

export const AfterCareSection = ({ hasSpecialBackground }: { hasSpecialBackground?: boolean }) => {
  const { isMoreThanMd, isMoreThanSm, isMoreThanLg } = useBreakpoint();
  const classes = useAftercareStyles();

  return (
    <Box marginTop={"90px"} className={classes.root} position={"relative"}>
      {hasSpecialBackground && (
        <TopBox bgColor="#f7f7f7" outsideBgColor="#fff" boxHeight={isMoreThanMd ? "145px" : "71px"} />
      )}
      <Box bgcolor={hasSpecialBackground ? "#f7f7f7" : "#fff"}>
        <Box
          textAlign={"center"}
          fontSize={isMoreThanSm ? "28px" : "20px"}
          color={"#1e073f"}
          fontWeight={500}
          width={"100%"}
          position={hasSpecialBackground ? "absolute" : "relative"}
          top={hasSpecialBackground ? "90px" : "inherit"}
        >
          What makes Swyft Energy's Aftercare <span className={classes.different}>different</span>
        </Box>
        <Box
          display="grid"
          gridTemplateColumns={`repeat(${isMoreThanMd ? "3" : isMoreThanSm ? "2" : "1"}, minmax(0, 1fr))`}
          justifyItems={"center"}
          gridGap={isMoreThanSm ? "35px" : "10px"}
          margin="auto"
          bgcolor={hasSpecialBackground ? "#f7f7f7" : "#fff"}
          pt={!hasSpecialBackground ? 0 : isMoreThanMd ? "0" : "60px"}
          className={classes.container}
        >
          {DataAftercare.map((item, index) => {
            const isW1 = index <= 2;
            return (
              <Box key={index}>
                <Box textAlign="center" mb={isMoreThanSm ? 5 : 2} width={"100%"} height={110} mt={10}>
                  <img src={item.src} alt={item.description} style={{ margin: "0 auto" }} />
                </Box>
                <Box
                  fontSize={isMoreThanSm ? 22 : 18}
                  fontWeight={500}
                  textAlign="center"
                  width={isW1 ? 300 : "full"}
                  height={!isMoreThanLg && isMoreThanMd ? "63px" : "auto"}
                  m="auto"
                  mb={2}
                  color={"#1e073f"}
                >
                  <div dangerouslySetInnerHTML={{ __html: item.title }} />
                </Box>
                <Box fontSize={isMoreThanSm ? 16 : 14} textAlign="center">
                  {item.description}
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
      {hasSpecialBackground && (
        <BotBox bgColor="#f7f7f7" outsideBgColor="#fff" boxHeight={isMoreThanMd ? "145px" : "71px"} />
      )}
    </Box>
  );
};
